import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const StyledEntityItem = styled.div`
  padding-left: ${({ hideIcon }) => hideIcon ? '0px' : '12px'};
  padding-top: 3px;
  color: ${({ dark, theme }) => dark ? theme.colors.darkGrey : 'white'};
  width: auto;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-weight: 100;
  display: block;
  overflow: hidden;
`;

export const EntityIcon = styled.div`
  vertical-align: middle;
  background-image: ${({ logo_url }) => `url('${logo_url}')`};
  width: ${({ width }) => width || '25px'};
  height: ${({ height }) => height || '25px'};
  border-radius: 100%;
  background-color: white;
  float: left;
  margin: 0 4px;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
`;

export const EntityItemContainer = styled(Link)`
  display: block;
  height: 32px;
  padding: 0 16px 0 0;
`;

export const EntityItemInlineContainer = styled(Link)`
  display: inline-block;
  font-size: 12px;
  max-width: 50%;
  vertical-align: middle;
`;

export const EntityItemWithContentContainer = styled.div`
  display: block;
  height: 32px;
  padding: 0 16px 0 0;

  ${StyledEntityItem} {
    color: ${({ theme }) => theme.colors.graphPalette[1]};
    display: inline-block;
    width: 100%;
    vertical-align: middle;
  }

  ${EntityItemInlineContainer} {
    &:nth-child(1) {
      ${StyledEntityItem} {
        font-weight: 500;
        margin-right: 5px;
      }
    }
    &:nth-child(2) {
      pointer-events: none;
      ${StyledEntityItem} {
        font-weight: normal;
        color: ${({ theme }) => theme.colors.graphPalette[2]};
        padding-top: 0;
      }
    }
  }
`;
